export class InventoryContract {
    id: string;
    name: string;
    startDate: Date = new Date();
    endDate: Date = new Date();
}